import { TypeAsserter } from '@attain-apps/type-guards'

import type { FeatureFlags } from './feature-flags'

let _registeredFeatureFlags: FeatureFlags | undefined

/**
 * Registers and returns the given {@link FeatureFlags}
 *
 * Any subsequent calls to {@link get} or {@link tryGet} will return the given
 * {@link FeatureFlags}
 */
export function register<TFeatureFlags extends FeatureFlags>(
  flags: TFeatureFlags,
): TFeatureFlags {
  return (_registeredFeatureFlags = flags)
}

/**
 * Returns the {@link FeatureFlags} that were last {@link register registered},
 * throwing an error if {@link register} has not been called
 *
 * @see {@link tryGet}
 */
export function get(): FeatureFlags {
  return TypeAsserter.validate(
    _registeredFeatureFlags,
    TypeAsserter.assertIsNotNullish,
  )
}

/**
 * Returns the {@link FeatureFlags} that were last {@link register registered},
 * returning `undefined` if {@link register} has not been called
 *
 * @see {@link get}
 */
export function tryGet(): FeatureFlags | undefined {
  return _registeredFeatureFlags
}
